import React from 'react';
import { InputGroup, Button } from 'react-bootstrap';
import { updateSpecialProductQuantityLoaded } from '../api';
import OrderLinksDropdown from './ui/OrderLinksDropdown';
import { isPropietarioOrAdminOrGestion } from '../services/AuthService';

const SpecialProductCarrierRow = ({ item, editable, onUpdate }) => {
  const adjustQuantity = async (newQty) => {
    const currentQty = item.quantityLoaded || 0;
    if (newQty === currentQty) return;
    
    try {
      await updateSpecialProductQuantityLoaded(item.id, newQty);
      onUpdate(item.id, newQty);
    } catch (error) {
      console.error('Error actualizando cantidad cargada:', error);
    }
  };

  return (
    <tr className={item.quantityLoaded >= item.quantity ? 'table-success' : (item.quantityLoaded > 0 ? 'table-warning' : 'table-danger')}>
      <td>{item.productPrice?.type?.typeName || '-'}</td>
      <td>
        <span className="badge bg-info me-2">Especial</span>
        {item.productPrice?.model?.modelName || '-'}
      </td>
      <td>-</td>
      <td>-</td>
      <td>{item.quantity}</td>
      <td>-</td>
      {isPropietarioOrAdminOrGestion() && !editable && (
        <td>
          <OrderLinksDropdown 
            orderIds={item.orderIds} 
            orderExternalIds={item.orderExternalIds} 
            isEditing={editable}
          />
        </td>
      )}
      <td>
        {editable ? (
          <InputGroup className="justify-content-center">
            <Button
              variant="outline-secondary"
              size="lg"
              onClick={() => adjustQuantity(Math.max(0, (item.quantityLoaded || 0) - 1))}
              data-testid={`decrease-btn-${item.id}`}
            >
              -
            </Button>
            <InputGroup.Text
              className="mx-2"
              style={{ minWidth: '2.5rem', textAlign: 'center' }}
              data-testid={`quantity-display-${item.id}`}
            >
              {item.quantityLoaded || 0}
            </InputGroup.Text>
            <Button
              variant="outline-secondary"
              size="lg"
              onClick={() =>
                adjustQuantity(
                  Math.min(item.quantity, (item.quantityLoaded || 0) + 1)
                )
              }
              data-testid={`increase-btn-${item.id}`}
            >
              +
            </Button>
          </InputGroup>
        ) : (
          <span>{item.quantityLoaded || 0}</span>
        )}
      </td>
    </tr>
  );
};

export default SpecialProductCarrierRow;